@if (value(); as value) {
  <label class="fieldset-label select-none">
    <input
      type="checkbox"
      [checked]="isSelected() ? 'checked' : undefined"
      class="checkbox border-neutral-300 checked:border-primary rounded checkbox-primary"
    />
    <p class="text-gray-800 font-normal !text-sm">{{ value.label }}</p>
  </label>
}
